import { ConfigFilterItem, ConfigItem } from 'Core/interfaces/filters'

export enum PcProductWeightFormFields {
	materialName = 'materialName',
	materialNameNl = 'materialNameNl',
	productTypeId = 'productTypeId',
	lowBaleWeight = 'lowBaleWeight',
	highBaleWeight = 'highBaleWeight',
	processingCenterId = 'processingCenterId',
	isActive = 'isActive'
}

export enum PCProductWeightSearchResultFields {
	searchByMaterialName = 'searchByMaterialName',
	searchByProductType = 'searchByProductType'
}

export enum PCProductWeightFilterFields {
	includeInactive = 'includeInactive',
	processingCenterId = 'processingCenterId'
}

export declare namespace PcProductWeight {
	interface Basic {
		id: number
		materialName: string
		materialNameNl: string
		productType: Entity
		lowBaleWeight: number
		highBaleWeight: number
		processingCenter: Entity
		isActive: boolean
	}

	namespace Form {
		interface Generic {
			[PcProductWeightFormFields.materialName]: string
			[PcProductWeightFormFields.materialNameNl]: string
			[PcProductWeightFormFields.lowBaleWeight]: number | null
			[PcProductWeightFormFields.highBaleWeight]: number | null
			[PcProductWeightFormFields.productTypeId]: number | null
			[PcProductWeightFormFields.processingCenterId]: number | null
			[PcProductWeightFormFields.isActive]: boolean
		}
	}

	namespace Request {
		interface Generic {
			[PcProductWeightFormFields.materialName]: string
			[PcProductWeightFormFields.materialNameNl]: string
			[PcProductWeightFormFields.lowBaleWeight]: number
			[PcProductWeightFormFields.highBaleWeight]: number
			[PcProductWeightFormFields.productTypeId]: number
			[PcProductWeightFormFields.processingCenterId]: number
			[PcProductWeightFormFields.isActive]: boolean
		}
	}

	namespace Search {
		interface Config {
			[PCProductWeightSearchResultFields.searchByMaterialName]: ConfigItem<PCProductWeightSearchResultFields>
			[PCProductWeightSearchResultFields.searchByProductType]: ConfigItem<PCProductWeightSearchResultFields>
		}
		interface Suggestions {
			[PCProductWeightSearchResultFields.searchByMaterialName]: string[]
			[PCProductWeightSearchResultFields.searchByProductType]: string[]
		}
	}

	namespace Filters {
		export interface Config {
			[PCProductWeightFilterFields.includeInactive]: ConfigFilterItem<string, boolean>
			[PCProductWeightFilterFields.processingCenterId]: ConfigFilterItem<string, string>
		}
	}
}
